export default function cart() {
	$('.woocommerce').on('change', 'input.qty', function(){
		$('.woocommerce input.qty').trigger('click');
		$("[name='update_cart']").trigger('click');
	});
}
